import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          当前最受关注的影视话题标签，发现大家都在看什么
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topicsData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-lg p-4 md:p-5 cursor-pointer hover:bg-background-200 transition-colors"
            >
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100 rounded-full whitespace-nowrap">
                  {item.label}
                </span>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-fire-line text-xs"></i>
                  {item.heat.toLocaleString()}
                </span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-accent-600 transition-colors">
                {item.tag}
              </h3>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}